import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import { PaginateQuery } from "core/resources/types/shared";
import { useCallback, useState } from "react";
import { parse } from "query-string";
import { useQueryParams, NumberParam, StringParam } from "use-query-params";

function useFiltro() {
  const [filtro, setFiltro] = useState<PaginateQuery & { mes?: string }>(() => {
    const p: any = parse(window.location.search);

    return {
      page: 1,
      limit: BaseFiltroPaginate.Limit,
      mes: undefined,
      ...p,
    };
  });

  const [, setQuery] = useQueryParams({
    limit: NumberParam,
    page: NumberParam,
    search: StringParam,
  });

  const onChangeFiltro = useCallback(
    (prop, value?: any) => {
      if (prop === undefined) {
        setFiltro(() => {
          const next = { limit: BaseFiltroPaginate.Limit, page: 1 };

          setQuery(next);

          return next;
        });
      } else if (typeof prop !== "string") {
        setFiltro((prev: any) => {
          const next = { ...prev, ...prop };

          setQuery(next);

          return next;
        });
      } else {
        setFiltro((prev: any) => {
          const next = { ...prev, [prop]: value };

          setQuery(next);

          return next;
        });
      }
    },
    [setQuery]
  );

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltro;
